import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type Manager = {
    id: number
    name: string
    position: number
    photo: string
    photo_minify: string
    post: string
    email?: string
}

export type ManagerDto = {
    name: string
    position: number
    photo: string
    photo_minify: string
    post: string
}

export const managerApi = createApi({
    reducerPath: 'managerApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["MANAGERS"],
    endpoints: builder => ({
        getAllManagers: builder.query<Manager[], []>({
            query: () => ({ url: `/manager` }),
            providesTags: ["MANAGERS"]
        }),
        getAllManagersEn: builder.query<Manager[], []>({
            query: () => ({ url: `/manager?lang=en` }),
            providesTags: ["MANAGERS"]
        }),
        getManager: builder.query<Manager, { id: number }>({
            query: ({ id }) => ({ url: `/manager/${id}` }),
            extraOptions: {includeToken: false},
            providesTags: ["MANAGERS"]
        }),
        createManager: builder.mutation<any, ManagerDto>({
            query: data => ({ url: `/manager`, method: 'POST', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["MANAGERS"]
        }),
        deleteManagersByIds: builder.mutation<any, any>({
            query: data => ({ url: `/manager/delete-by-ids`, method: 'POST', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["MANAGERS"]
        }),
        updateManager: builder.mutation<any, any>({
            query: data => ({ url: `/manager/${data.id}`, method: 'PATCH', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["MANAGERS"]
        }),
        updateManagersEn: builder.mutation<any, any>({
            query: data => ({ url: `/manager/en/update/${data.id}`, method: 'PATCH', body: {name: data.name, post: data.post} }),
            invalidatesTags: ["MANAGERS"]
        }),
    })
})

export const {
    useGetAllManagersQuery,
    useGetAllManagersEnQuery,
    useGetManagerQuery,
    useCreateManagerMutation,
    useDeleteManagersByIdsMutation,
    useUpdateManagerMutation,
    useUpdateManagersEnMutation
} = managerApi
